import * as React from "react";
import type { SVGProps } from "react";
const SvgDocDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 8.25a.75.75 0 0 1 .75.75v4.19l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V9a.75.75 0 0 1 .75-.75"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.25 7A4.75 4.75 0 0 1 9 2.25h4.343c1.26 0 2.468.5 3.359 1.391l1.657 1.657a4.75 4.75 0 0 1 1.391 3.359V17A4.75 4.75 0 0 1 15 21.75H9A4.75 4.75 0 0 1 4.25 17zM9 3.75A3.25 3.25 0 0 0 5.75 7v10A3.25 3.25 0 0 0 9 20.25h6A3.25 3.25 0 0 0 18.25 17V8.657a3.25 3.25 0 0 0-.952-2.298l-1.657-1.657a3.25 3.25 0 0 0-2.298-.952z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocDownload;
